import {
  IButtonControl,
  IButtonInputMD,
  IButtonInputWithIconMD,
  tg,
} from '@infotech-soe/metaschema';

import {
  ButtonFormControlViewModel,
  FormControlViewModelType,
} from '../../view-model/FormControlViewModel';

const isButtonWithIcon = (x: IButtonInputMD): x is IButtonInputWithIconMD =>
  tg.hasProperty(x, 'icon');

const buildButtonControl = async (
  item: IButtonControl,
  label: string
): Promise<ButtonFormControlViewModel> => {
  const result: ButtonFormControlViewModel = {
    columns: item.columns,
    type: FormControlViewModelType.BUTTON,
    hasValue: false,
    hasHistory: false,
    name: item.name,
    label,
    updater: item.updater,
    disabled: item.disabled,
    visible: item.visible,
    variant: item.variant,
  };
  if (isButtonWithIcon(item)) {
    result.icon = item.icon;
    result.iconPosition = item.iconPosition;
  }
  return result;
};

export default buildButtonControl;
